export default [
  {
    title: '分成月份',
    key: 'reportMonth',
    width: 62
  },
  {
    title: '游戏组',
    key: 'gameName',
    width: 140
  },
  // {
  //   title: '游戏ID',
  //   key: 'gameId'
  // },
  {
    title: '分成比例',
    key: 'cpRate'
  },
  {
    title: '更新人',
    key: 'opName'
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 114
  },
  {
    title: '操作',
    key: 'control',
    width: 104
  }
]
